module.exports = __webpack_public_path__ + "media/images/resetpass-pic-575b4e81.svg";